import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IProductNetworkTypeModel } from '@apps-common/types/management/product'

export const MANAGEMENT_QUERY_KEY_GET_PRODUCT_NETWORK_TYPES = () => ['getManagementProductNetworkTypes']

export const getProductNetworkTypes = async (): Promise<IProductNetworkTypeModel[]> =>
  axios.get('/management/product/GetProductNetworkTypes').then((res) => res.data?.data)

type QueryFnType = typeof getProductNetworkTypes

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetProductNetworkTypes = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_PRODUCT_NETWORK_TYPES(),
    queryFn: () => getProductNetworkTypes()
  })
